function validateLength (input, ...params) {
  if (!input) {
    return false
  }
  let valid = true
  if (params.length === 1) {
    const min = params[0]
    if (input.length < min) {
      valid = false
    }
  }
  if (params.length === 2) {
    const max = params[1]
    if (input.length > max) {
      valid = false
    }
  }
  return valid
}

function numeric (input, params) {
  const parsed = Number.parseFloat(input)
  const isNumeric = !Number.isNaN(parsed)
  if (!input) {
    return false
  }
  if (!isNumeric) {
    return false
  }

  let valid = true
  if (typeof params.minimum !== 'undefined' && parsed < params.minimum) {
    valid = false
  }
  if (typeof params.maximum !== 'undefined' && parsed > params.maximum) {
    valid = false
  }
  return valid
}

function required (input) {
  if (!input) {
    return false
  }
  return input.toString().replace(/\s+/, '') !== ''
}

export default {
  length: validateLength,
  required,
  numeric
}

export { validateLength }
